import type {ComponentType} from 'react';

import {useDraggable} from '@dnd-kit/core';

import {FORM_FIELD_DRAG_TYPE} from './consts';
import {FieldCardPreview} from './field-card-preview';
import type {DraggableCardData, FormFieldDragData} from './types';

interface Props {
    id: string;
    icon: ComponentType<any>;
    label: string;
    dragData: FormFieldDragData;
}

export function AddableFieldCard(props: Props) {
    const data: DraggableCardData = {
        fieldData: props.dragData,
        label: props.label,
        Icon: props.icon,
    };

    const {attributes, listeners, setNodeRef, isDragging} = useDraggable({
        id: `${FORM_FIELD_DRAG_TYPE}:${props.id}`,
        data,
    });

    return (
        <div ref={setNodeRef} {...listeners} {...attributes}>
            <FieldCardPreview Icon={props.icon} label={props.label} isDragging={isDragging} />
        </div>
    );
}
